import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/helpers/common.service';
import { AppService } from 'src/app/providers/appservice/app.service';
import { DashboardService } from 'src/app/providers/home/dashboard.service';
import { environment } from 'src/environments/environment';
import { createApi } from 'unsplash-js';
import { ActivatedRoute } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { debounce } from 'lodash';
import { LoadingService } from 'src/app/providers/loading/loading.service';
import { SharedService } from 'src/app/modules/home/data.service';

@Component({
  standalone: false,
  selector: 'app-openimageuploadpopup',
  templateUrl: './openimageuploadpopup.component.html',
  styleUrls: ['./openimageuploadpopup.component.scss']
})
export class openimageuploadpopupComponent implements OnInit, AfterViewInit, OnDestroy {
  private static readonly NESTED_MODAL_Z_INDEX = 1200;
  private static readonly NESTED_BACKDROP_Z_INDEX = 1199;
  company: any;
  gallery: any[] = [];
  line_icons: any[] = [];
  line_icons_categories: any[] = [];
  line_icons_selected_cat: any[] = [];
  line_icons_temp_selected_cat: any[] = [];
  filteredLineIconCategories: any[] = [];
  searchText: string = '';
  rich_icons: any[] = [];
  uploaded: any[] = [];
  unsplashImages: any[] = [];
  unsplashPageNum: number = 0;
  iframeLoaded: boolean = false;
  currentAccountId: any;
  private searchUnsplash = new Subject<string>();
  lineIconsPageNum: number = 0;
  private searchLineIcons = new Subject<string>();
  activeItem: string = "upload";
  @Output() callback: EventEmitter<any> = new EventEmitter<any>();
  // @Input() callback: (url: string, inputObj: any, imageType: string, callbackData?: any) => void;
  @Input() modalId = 'ImageUpload';
  @Input() appendToBody = false;
  @Input() inputObj: any;
  @Input() buttonsRef: any;
  @Input() activeUserIndex: any;
  @Input() activeUserAvatar: any;
  @ViewChild('modalRoot', { static: false }) modalRoot?: ElementRef<HTMLElement>;
  @ViewChild('closeModal', { static: false }) closeModal: any;
  @ViewChild('richIconsIFrame', { static: false }) richIconsIFrame: any;
  private readonly onModalHidden = () => this.onNestedModalHidden();
  debouncedUnsplashFun: any;
  debouncedLineIconsFun: any;
  searchResponseText: string = 'Please select a category or use search to get the icons'
  constructor(private commonService: CommonService, private dashboardService: DashboardService,
    private appService: AppService, private route: ActivatedRoute, private loaderService: LoadingService, private sharedService: SharedService,
    private cdr: ChangeDetectorRef
  ) {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    // this.searchUnsplash.pipe(debounceTime(100)).subscribe((searchTerm: string) => {
    //   this.unsplashPageNum = 0;
    //   this.getUnsplash(searchTerm);
    // });      
    // this.searchLineIcons.pipe(debounceTime(100)).subscribe((searchTerm: string) => {
    //   this.lineIconsPageNum = 0;
    //   if(searchTerm){
    //     this.getLineIcons(searchTerm);
    //   }
    // });      
    this.debouncedUnsplashFun = debounce(this.getUnsplash, 100);
    this.debouncedLineIconsFun = debounce(this.getLineIcons, 100);
  }

  ngOnInit(): void {
    this.commonService.getCompany(this.appService.currentActivatedFeature.strategyId).subscribe(x => {
      this.company = x;
      this.cdr.detectChanges();
    })
    this.currentAccountId = this.dashboardService.accountDetails?.account?._id || this.dashboardService.currentAccId;
    this.getImageGallery();
    // this.getLineIcons('');
    this.getLineIconCategories();
    this.getUnsplash('strategy');
  }

  ngAfterViewInit(): void {
    const modalEl = this.getModalElement();
    if (!modalEl) {
      return;
    }

    if (this.appendToBody && modalEl.parentElement !== document.body) {
      document.body.appendChild(modalEl);
    }

    modalEl.addEventListener('hidden.bs.modal', this.onModalHidden);
    modalEl.addEventListener('shown.bs.modal', () => {
      if (this.appendToBody) {
        this.fixNestedModalStacking(modalEl);
      }
    });
  }

  ngOnDestroy(): void {
    const modalEl = this.getModalElement();
    if (modalEl) {
      modalEl.removeEventListener('hidden.bs.modal', this.onModalHidden);
      const bootstrap = (window as any).bootstrap;
      bootstrap?.Modal?.getInstance(modalEl)?.hide();
    }
    this.enablePrimeDialogMask();
    this.cleanupBootstrapModalState();
  }

  open(): void {
    const modalEl = this.getModalElement();
    if (!modalEl) {
      return;
    }

    if (this.appendToBody) {
      this.disablePrimeDialogMask();
    }

    const bootstrap = (window as any).bootstrap;
    if (!bootstrap?.Modal) {
      return;
    }

    bootstrap.Modal.getOrCreateInstance(modalEl).show();
  }

  private getModalElement(): HTMLElement | null {
    return this.modalRoot?.nativeElement ?? document.getElementById(this.modalId);
  }

  private disablePrimeDialogMask(): void {
    document.querySelectorAll('.p-dialog-mask').forEach((mask) => {
      (mask as HTMLElement).style.pointerEvents = 'none';
    });
  }

  private enablePrimeDialogMask(): void {
    document.querySelectorAll('.p-dialog-mask').forEach((mask) => {
      (mask as HTMLElement).style.pointerEvents = '';
    });
  }

  private fixNestedModalStacking(modalEl: HTMLElement): void {
    modalEl.style.zIndex = String(openimageuploadpopupComponent.NESTED_MODAL_Z_INDEX);
    const backdrops = document.querySelectorAll('.modal-backdrop.show');
    const backdrop = backdrops[backdrops.length - 1] as HTMLElement | undefined;
    if (backdrop) {
      backdrop.style.zIndex = String(openimageuploadpopupComponent.NESTED_BACKDROP_Z_INDEX);
    }
  }

  private onNestedModalHidden(): void {
    if (!this.appendToBody) {
      return;
    }
    this.enablePrimeDialogMask();
    this.cleanupBootstrapModalState();
  }

  private cleanupBootstrapModalState(): void {
    if (document.querySelectorAll('.modal.show').length > 0) {
      return;
    }

    document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }

  receiveMessage(event: MessageEvent) {
    // Handle the received message from the iframe
    if ((/^react-devtools/gi).test(event.data.source)) {
      // console.log("DEBUG: event data: ", event.data);
      // Sometimes the event.data is coming as 
      // {source: "react-devtools-content-script"}. What the hell is this? 
      return;
    }
    this.setImage(`	https://main--inspiring-bonbon-e38161.netlify.app/${event.data}`);
  }

  onIframeLoad() {
    this.iframeLoaded = true;
  }

  setActiveItem(item: string) {
    this.activeItem = item;
    this.iframeLoaded = false;
  }

  onSearchUnsplash(event: any) {
    const searchTerm = event.target.value;
    this.debouncedUnsplashFun(searchTerm);
    // this.searchUnsplash.next(searchTerm);
  }

  getUnsplash(search = 'strategy') {
    const unsplash = createApi({
      accessKey: 'qe210R3PkD-OZ4aHt5dIO1JE-HvoHySC3Z4MIoF9DFw',
    });
    // this.unsplashPageNum++;
    unsplash.search.getPhotos({
      query: search,
      // page: this.unsplashPageNum,
      page: 1,
      perPage: 20,
    })
      .then((result) => {
        if (result.errors) {
          console.error('Failed to fetch random photo', result.errors);
          this.cdr.markForCheck();
        } else {
          this.unsplashImages = result.response.results;
          // this.unsplashImages = this.unsplashImages.concat(result.response.results);
        }
        this.cdr.markForCheck();
      }).catch((error) => {
        console.error('Failed to fetch random photo', error);
        this.cdr.markForCheck();
      });
  }

  getImageGallery() {
    this.dashboardService.getAccountDetails$.subscribe(v => {
      const accId = v?.account?._id;
      if (accId) {
        this.dashboardService.getAccountImages(accId)
          .subscribe(res => {
            this.gallery = res;
            this.uploaded = res.uploaded.filter((obj: any) => obj.url);
            this.cdr.markForCheck();
          });
      }
      this.cdr.detectChanges();
    });
    // if(!this.dashboardService?.currentAccId && this.dashboardService?.accountDetails?.hq_company_id == this.company?.strategyId ) {    
    //     this.dashboardService.currentAccId =this.company['acc'];
    // }
    // else {
    //   this.dashboardService.currentAccId =this.company['acc'];
    // }
  }

  getLineIconCategories() {
    this.dashboardService.getLineIconCategories().subscribe(res => {
      this.line_icons_categories = res;
      this.filteredLineIconCategories = res;
      this.cdr.detectChanges();
    })
  }

  onSearchLineIcons(event: any) {
    const searchTerm = event.target.value;
    // this.searchLineIcons.next(searchTerm);
    this.debouncedLineIconsFun(searchTerm);
    this.line_icons_selected_cat = [];
    this.line_icons_temp_selected_cat = [];
  }

  getLineIcons(search: string = '') {
    this.line_icons_selected_cat = !search ? this.line_icons : [];
    this.dashboardService.getLineIcons(search, this.line_icons_selected_cat).subscribe(res => {
      this.line_icons = res
      if (this.line_icons?.length == 0) {
        this.searchResponseText = 'No Icons found for the specific search';
      }
      this.cdr.detectChanges();
    })
  }

  applyLineIconCategory() {
    this.line_icons_selected_cat = this.line_icons_temp_selected_cat
  }

  setLineIconCategory(category: string) {
    this.line_icons_temp_selected_cat.push(category);
  }

  resetLineIconCategories() {
    this.line_icons_temp_selected_cat = [];
  }

  removeLineIconCategory(event: any, category: string) {
    event.stopPropagation();
    this.line_icons_temp_selected_cat = [];
    // this.line_icons_temp_selected_cat.splice(this.line_icons_temp_selected_cat.indexOf(category), 1);
    // this.cdr.detectChanges();
    // console.log(this.line_icons_temp_selected_cat, this.line_icons_temp_selected_cat.indexOf(category));
  }

  getLineIconURL(file: string, folder: string) {
    return `${environment.API_URL}line-icons/${folder}/${file}`;
  }

  OnImageSelected(event: any) {
    this.loaderService.apiLoader = true;
    if (event.target.files.length > 0 && event.target.files[0].type.startsWith('image/')) {
      const file = event.target.files[0];
      let data = {
        pic: file,
        acc: this.currentAccountId,
        // strat: this.appService.currentActivatedFeature.strategyId
      }
      let formData: FormData = new FormData();
      formData.set('pic', file);
      // formData.append('pic', event.target.files[0], event.target.files[0].name);
      formData.append('acc', this.currentAccountId);
      // formData.append('strat', this.appService.currentActivatedFeature.strategyId);
      this.dashboardService.UploadImage(formData)
        .subscribe({
          next: (res) => {
            this.uploaded.push(res);
            event.target.value = '';
            this.sharedService.alertNotification('success', 'Success', 'Image was uploaded');
            this.cdr.detectChanges();
          },
          error: (e) => {
            this.sharedService.alertNotification('error', 'Invalid file format', 'Please select only image files');
            this.cdr.markForCheck();
            // this.sharedService.alertNotification('error', 'Error', e.error.message);
          },
          complete: () => { this.loaderService.apiLoader = false; this.cdr.markForCheck(); }
        })
    } else {
      this.sharedService.alertNotification('error', 'Invalid file format', 'Please select only image files');
      event.target.value = '';
    }
  }

  setImage(url: string) {
    this.dashboardService.getSelectedImage(url)
      .subscribe(signedUrl => {
        this.callback.emit({ url, imageType: this.activeItem, signedUrl });
        this.closeModal?.nativeElement?.click();
        this.cdr.detectChanges();
      })
  }

  setLineIcon(file: string, folder: string) {
    this.setImage(this.getLineIconURL(file, folder))
  }

  closeModalFun() {
    this.line_icons = [];
    this.line_icons_temp_selected_cat = [];
    this.callback.emit({ closeModal: true })
  }

  deleteImage(event: any, file: any) {
    event.stopPropagation();
    const { url, acc } = file;
    this.dashboardService.deleteImage({ acc, url }).subscribe(res => {
      this.uploaded = res.uploaded.filter((obj: any) => obj.url);
      this.cdr.detectChanges();
    });
  }

  getImageUrl(file: any) {
    if (file.url)
      return environment.S3_API_URL + this.currentAccountId + '/image-gallery/' + file.url;
    else
      return '';
  }


  updateLineIconCategoryAndFetchIcons(category: string, search: string = ''): void {
    const categoryIndex = this.line_icons_temp_selected_cat.indexOf(category);
    if (categoryIndex === -1) {
      this.line_icons_temp_selected_cat.push(category);
    } else {
      this.line_icons_temp_selected_cat.splice(categoryIndex, 1);
    }

    this.line_icons_selected_cat = !search ? this.line_icons_temp_selected_cat : [];
    if (search || this.line_icons_selected_cat.length !== 0) {
      this.dashboardService
        .getLineIcons(search, this.line_icons_selected_cat)
        .subscribe(res => {
          this.line_icons = res;
          this.cdr.markForCheck();
        });
    } else {
      this.line_icons = [];
      this.searchResponseText = 'Please select a category or use search to get the icons';
      this.cdr.detectChanges();
    }
    if (this.line_icons_temp_selected_cat.length > 0) {
      this.line_icons_selected_cat = this.line_icons_temp_selected_cat.slice();

      this.dashboardService.getLineIcons(search, this.line_icons_selected_cat).subscribe(res => {
        this.line_icons = res;
        this.cdr.markForCheck();
      });
    }
    else {
      this.line_icons = [];
      this.searchResponseText = 'Please select a category or use search to get the icons';
      this.cdr.detectChanges();
    }

  }

  filterLineIconCategories() {
    if (this.searchText.trim() === '') {
      this.filteredLineIconCategories = this.line_icons_categories;
    } else {
      this.filteredLineIconCategories = this.line_icons_categories.filter(
        (cat) => cat.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
  }

}


